import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiAutocomplete from './MuiAutocomplete';
import MuiSwitch from './MuiSwitch';
import MuiSlider from './MuiSlider';
import MuiAccordion from './MuiAccordion';
import MuiAccordionSummary from './MuiAccordionSummary';
import MuiTextField from './MuiTextField';

export default {
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiAutocomplete,
  MuiSwitch,
  MuiSlider,
  MuiAccordion,
  MuiAccordionSummary,
  MuiTextField,
};
